var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('autogen-view',{on:{"change-resource":_vm.changeResource}}),(_vm.isSummaryResouce)?_c('quota-summary-resource',{attrs:{"resource":_vm.resource,"tabs":_vm.$route.meta.tabs}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }